import { useState, useEffect } from 'react';
import ModalV2 from '../../../../../components/ModalV2';
import useModal from '../../../../../hooks/useModal';

export const CREATE_WORKFLOW_MODAL = 'create-workflow';

export default function CreateWorkflowModal() {
  const { isOpen, data, close } = useModal(CREATE_WORKFLOW_MODAL);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  useEffect(() => {
    if (!isOpen) {
      setName('');
      setDescription('');
    }
  }, [isOpen]);

  const handleCreate = () => {
    if (!name.trim()) return;
    data?.onCreate?.(name.trim(), description.trim());
    close();
  };

  return (
    <ModalV2 name={CREATE_WORKFLOW_MODAL} className="w-full max-w-md">
      <div className="py-2">
        <h3 className="text-lg font-semibold text-gray-800">Create Workflow</h3>
        <p className="text-sm text-gray-400 mt-0.5">Set up a new automation workflow</p>
      </div>
      <div className="py-4 space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">Name</label>
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. New user onboarding"
            className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-200 focus:border-blue-400"
            autoFocus
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1.5">
            Description <span className="text-gray-400 font-normal">(optional)</span>
          </label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="What does this workflow do?"
            rows={3}
            className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-xl resize-none focus:outline-none focus:ring-2 focus:ring-blue-200 focus:border-blue-400"
          />
        </div>
      </div>
      <div className="flex justify-end gap-2 pt-2">
        <button
          onClick={close}
          className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded-xl transition"
        >
          Cancel
        </button>
        <button
          onClick={handleCreate}
          disabled={!name.trim()}
          className="px-5 py-2 text-sm text-white bg-[#2461DD] hover:bg-[#1d4fba] disabled:opacity-40 disabled:cursor-not-allowed rounded-xl transition"
        >
          Create
        </button>
      </div>
    </ModalV2>
  );
}
